import axios from 'axios'
import { api } from '@/global'
import { authHeader } from '@/services/auth-header'

function register(data){
    return axios.post( `${api.public}register`, data )
}

function list(params = ''){
    return axios.get( `${api.wp}users${params}`, {
        headers: authHeader()
    })
}

function add(data){
    return axios.post( `${api.private}add-user`, data, {
        headers: authHeader()
    })
}

function update(data){
    let id = data.id
    delete data.id
    return axios.post( `${api.private}update-user/${id}`, data, {
        headers: authHeader()
    })
}

function block(id){
    return axios.post( `${api.private}user/block/${id}`, {}, {
        headers: authHeader()
    })
}

export {
    register,
    list,
    add,
    update,
    block
}